export const questionsOne = [
  {
    id: 1,
    question:
      "Ramesh is taller than Vinay who is not as tall as Karan. Sanjay is taller than Anupam but shorter than Vinay. Who among them is the tallest?",
    answer: "None of these",
    options: ["Ramesh", "Karan", "Vinay", "None of these"],
    explanations: ["Cannot be determined."],
  },
  {
    id: 2,
    question: "TEN:DECIMAL :: ?",
    answer: "Two : Binary",
    options: [
      "Seven : Septet",
      "Four : Quartet",
      "Two : Binary",
      "Five : Quince",
    ],
    explanations: [
      "Decimal is a number system with ten as the base. Similarly, binary is a number system with two as the base. Others don't have a number system.",
    ],
  },
  {
    id: 3,
    question: "If DELHI is coded as CCIDD, how would you encode BOMBAY?",
    answer: "AMJXVS",
    options: ["AJMTVT", "AMJXVS", "MJXVSU", "WXYZAX"],
    explanations: [
      "The first, second, third, fourth, . . . . . letters of the word are moved one, two, three, four, . . . . . steps backward respectively to obtain the corresponding letters of the code.",
    ],
  },
  {
    id: 4,
    question: "Sphere : Ball",
    answer: "Cube : Dice",
    options: ["Circle : Disc", "Cube : Dice", "Line : Rope", "Triangle : Cone"],
    explanations: ["First denotes the three dimensional shape of the second."],
  },
  {
    id: 5,
    question:
      "Anil introduces Rohit as the son of the only brother of his father's wife. How is Rohit related to Anil.",
    answer: "Cousin",
    options: ["Cousin", "Son", "Uncle", "Brother"],
    explanations: [
      "Father's wife means mother; Mother's only brother means maternal uncle and uncle's son means cousin. So Rohit is Anil's cousin.",
    ],
  },
  {
    id: 6,
    question: "India and Pakistan are friendly countries.",
    answer: "Absurd",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: ["Absurd"],
  },
  {
    id: 7,
    question:
      "One term in the number series is Wrong. Find out the wrong term: 24, 27, 31, 33, 36",
    answer: "31",
    options: ["24", "27", "31", "33"],
    explanations: [
      "Each term is increased by 3 to obtain the next to them So in place of 31 and it should be 30",
    ],
  },
  {
    id: 8,
    question:
      "Which number would replace question mark in the series 7, 12, 19, ? , 39",
    answer: "28",
    options: ["29", "28", "26", "24"],
    explanations: [
      "7+5=12, 12+7=19, 19+9=28, 28+11=39. Hence '28' replace the question mark.",
    ],
  },
  {
    id: 9,
    question: "Chose the group of letters which is different from others.",
    answer: "PN",
    options: ["BD", "IK", "PN", "WY"],
    explanations: [
      "All other groups consist of two alternate letters in order, while in PN this group they are in reverse order",
    ],
  },
  {
    id: 10,
    question: "Choose the odd pair of words.",
    answer: "Mason : Wall",
    options: [
      "Painter : Gallery",
      "Actor : Stage",
      "Mason : Wall",
      "Farmer : Field",
    ],
    explanations: ["In all other parts, first works at the second."],
  },
  {
    id: 11,
    question: "Choose the odd pair of words.",
    answer: "Dog : Bitch",
    options: ["Cow : Calf", "Dog : Bitch", "Lion : Cub", "Insect : Larva"],
    explanations: [
      "In all other pairs, second is the young one of the first while in (b) second is the female of the first.",
    ],
  },
  {
    id: 12,
    question: "Choose the odd pair of words.",
    answer: "Japan : Singapore",
    options: [
      "China : Beijing",
      "Russia : Moscow",
      "Japan : Singapore",
      "Spain : Madrid",
    ],
    explanations: ["In all other pairs, second is the capital of first."],
  },
  {
    id: 13,
    question: "Choose the word which is least like other words in the group.",
    answer: "Oil",
    options: ["Curd", "Butter", "Oil", "Cheese"],
    explanations: ["All except oil is dairy products."],
  },
  {
    id: 14,
    question: "Choose the word which is least like other words in the group.",
    answer: "Mathematics",
    options: ["Geometry", "Algebra", "Trignometry", "Mathematics"],
    explanations: ["All except Mathematics are branches of Mathematics."],
  },
  {
    id: 15,
    question: "3 : 11 :: 7 : ?",
    answer: "51",
    options: ["22", "29", "18", "51"],
    explanations: ["If the first number is x, the second number is X^2 + 2."],
  },
  {
    id: 16,
    question: "Which number is like the given set of numbers : (3, 17, 31)",
    answer: "5",
    options: ["5", "15", "45", "49"],
    explanations: [
      "Set consists of all the prime numbers and the only prime number out of the given options is 5.",
    ],
  },
  {
    id: 17,
    question:
      "Chef is related to Restaurant in the same way as Druggist is related to...",
    answer: "Pharmacy",
    options: ["Medicine", "Pharmacy", "Store", "Chemist"],
    explanations: [
      "A chef works in a restaurant. Similarly, a druggist works in a pharmacy.",
    ],
  },
  {
    id: 18,
    question:
      "Mathematics is related to Numbers in the same way as History is related to...",
    answer: "Events",
    options: ["People", "Events", "Dates", "Wars"],
    explanations: [
      "Mathematics consists of Numbers. Similarly, History is consists of Events.",
    ],
  },
  {
    id: 19,
    question:
      "Mirror is related to Reflection in the same way Water is related to...",
    answer: "Refraction",
    options: ["Conduction", "Dispersion", "Immersion", "Refraction"],
    explanations: [
      "Light rays falling on a mirror undergo reflection and those falling on water undergo refraction.",
    ],
  },
  {
    id: 20,
    question:
      "Happiness is related to Sorrow in the Same way as Comfort is related to...",
    answer: "Hardship",
    options: ["Hardship", "Rest", "Poverty", "Difficulty"],
    explanations: ["The words in each pair are opposites of each other."],
  },
  {
    id: 21,
    question: "A small shelter for a dog",
    answer: "Kennel",
    options: ["Orchard", "Kennel", "Infirmary", "None of these"],
    explanations: [
      "Orchard - A piece of enclosed land planted with fruit trees.",
      "Kennel - A small shelter for a dog",
      "Infirmary - A place (as in a school or prison) where sick or injured individuals receive care and treatment.",
    ],
  },
  {
    id: 22,
    question: "One who does not express himself freely",
    answer: "Introvert",
    options: ["Insolvent", "Lunatic", "Narcissist", "Introvert"],
    explanations: [
      "Insolvent - Unable to pay debts owed.",
      "Lunatic - A person who is mentally ill",
      "Narcissist - A person who has an excessive interest in or admiration of themselves.",
      "Introvert - One who does not express himself freely",
    ],
  },
  {
    id: 23,
    question: "Someone in love with himself",
    answer: "Narcissist",
    options: ["Numismatist", "Philanthropist", "Narcissist", "Philogynist"],
    explanations: [
      "Numismatist - The study or collection of currency.",
      "Philanthropist - A person who seeks to promote the welfare of others.",
      "Narcissist - Someone in love with himself.",
      "Philogynist - A person who likes or admires women.",
    ],
  },
  {
    id: 24,
    question:
      "X introduces Y saying, `He is the husband of the granddaughter of the father of my father.` How is Y related to X?",
    answer: "Brother-in-law",
    options: ["Brother", "Son", "Brother-in-law", "Nephew"],
    explanations: [
      "Father's father ⇒ Grandfather; Grandfather's Granddaughter ⇒ Sister; Sister's husband ⇒  Brother-in-law. So, Y is X's brother-in-law.",
    ],
  },
  {
    id: 25,
    question:
      "The scientific study of the behaviour, structure, physiology, classification and distribution of animals",
    answer: "Zoology",
    options: ["Petrology", "Acoustics", "Zoology", "Odontology"],
    explanations: [
      "Petrology - The branch of science concerned with the origin, structure, and composition of rocks.",
      "Acoustics - The branch of physics concerned with the properties of sound.",
      "Zoology - The scientific study of the behavior, structure, physiology, classification, and distribution of animals.",
      "Odontology - The scientific study of the structure and diseases of teeth.",
    ],
  },

  {
    id: 26,
    question: "Cattle : Herd :: Sheep : ?",
    answer: "Flock",
    options: ["Flock", "Swarm", "Crowd", "Mob"],
    explanations: [
      "Herd is a group of cattle. Similarly, a flock is a collection of sheep. ",
    ],
  },
  {
    id: 27,
    question: "Muslims : Mosque :: Sikhs : ?",
    answer: "Gurudwara",
    options: ["Golden Temple", "Medina", "Fire Temple", "Gurudwara"],
    explanations: ["Second is he place of worship of the first."],
  },
  {
    id: 28,
    question: "Eye : Myopia :: Teeth : ?",
    answer: "Pyorrhoea",
    options: ["Pyorrhoea", "Cataract", "Trachoma", "Eczema"],
    explanations: ["Second is a disease of the first"],
  },

  {
    id: 29,
    question: "Car : Garage :: Aeroplane : ?",
    answer: "Hangar",
    options: ["Port", "Depot", "Hangar", "Harbour"],
    explanations: [
      "Car is temporarily parked in the Garage and Aeroplane is parked in a Hanger.",
    ],
  },
  {
    id: 30,
    question: "Cobbler : Leather :: Carpenter : ?",
    answer: "Wood",
    options: ["Furniture", "Wood", "Hammer", "Chair"],
    explanations: ["Cobbler makes things from leather and carpenter from wood"],
  },
  {
    id: 31,
    question:
      "How many 6's are there in the following sequence which are followed by 3 and preceded by 8? 5  4  8  6  3  2  7  1  8  6  8  9  8  1  3  6  8  9  0  8  6  3  1  3  6  8  4  3  2  3  5",
    answer: "2",
    options: ["4", "5", "2", "3"],
    explanations: ["The 6's that are followed by 3 and preceded by 8 are 2."],
  },
  {
    id: 32,
    question: "All the gold mines of the world is situated in Africa.",
    answer: "False",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: [
      "South Africa has produced more than 40 percent of the world's total production of gold but not all.",
    ],
  },
  {
    id: 33,
    question: "President is the first citizen of the country.",
    answer: "True",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: [
      "Constitution regards president as the first citizen of the country.",
    ],
  },
  {
    id: 34,
    question:
      "The Headquarters of the Southern Naval Command of the India Navy is located at Thiruvananthapuram.",
    answer: "False",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: [
      "The Headquarters of the Southern Naval Command of the India Navy is located at Kochi, Kerala.",
    ],
  },
  {
    id: 35,
    question:
      "Sachin Tendulkar has not played a single International T20 match for India.",
    answer: "False",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: ["Sachin has played just 1 T20I for India."],
  },
  {
    id: 36,
    question: "Unjumble this word - 'MEURMS'",
    answer: "SUMMER",
    options: ["MUMERS", "SUMMER", "RUMMES", "SUREMM"],
    explanations: ["MEURMS is unjumbled as SUMMER."],
  },
  {
    id: 37,
    question:
      "Accident is related to Carefulness in the same way as Disease is related to...",
    answer: "Sanitation",
    options: ["Sanitation", "Treatment", "Medicine", "Doctor"],
    explanations: [
      "Accident is related to Carefulness in the same way Disease is related to Sanitation as sanitation related to public health.",
    ],
  },
  {
    id: 38,
    question: "Indra : Rainfall",
    answer: "Cupid : Love",
    options: [
      "Shiv : Creation",
      "Shakespeare : Drama",
      "Cupid : Love",
      "Venus : War",
    ],
    explanations: [
      "Indra is the god of rainfall. Similarly, Cupid is the god of love.",
    ],
  },
  {
    id: 39,
    question: "Fish : Aquarium",
    answer: "Bee : Apiary",
    options: [
      "Teacher : Hostel",
      "Bee : Apiary",
      "Bird : Nest",
      "Child : School",
    ],
    explanations: [
      "Fishes are kept and reared in an aquarium. Similarly, bees are reared in an apiary.",
    ],
  },
  {
    id: 40,
    question:
      "Which is the number that comes next in the sequence: 4, 6, 12, 14, 28, 30, _",
    answer: "60",
    options: ["32", "60", "62", "64"],
    explanations: [
      "The term of the series is previous term x2,+2,x2,+2,x2,+2,..... and so on. Hence the next term would be 30×2=60",
    ],
  },
];
